import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzCheckboxComponent } from 'ng-zorro-antd/checkbox';
import { NzDividerComponent } from 'ng-zorro-antd/divider';

@Component({
  selector: 'app-recap-care-manager',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzDividerComponent, NzCheckboxComponent],
  templateUrl: './recap-care-manager.component.html',
  styleUrl: './recap-care-manager.component.scss',
})
export class RecapCareManagerComponent {
  isChecked: boolean = false;

  public setValue() {
    this.isChecked = !this.isChecked;
    localStorage.setItem('skipCareManagerIntro', JSON.stringify(this.isChecked));
  }
}
